import React from 'react';
import SiteNavBar from '../navigation/SiteNavBar';
import Footer from '../footer/Footer';
import CopyRight from '../footer/CopyRight';
import '../../../assets/css/main.css'
import '../../../assets/bootstrap/css/bootstrap.min.css'
import workprogress from '../../../images/work-inprogress.jpg'

const PickupLocation = () => {
    return (
        <div>
            <SiteNavBar />
            <div className="hero-area hero-bg" style={{ paddingTop: '3%' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9 offset-lg-2 text-center">
                            <div className="hero-text">
                                <div className="hero-text-tablecell" style={{ padding: '15% 0' }}>
                                    <p className="subtitle" style={{ fontSize: '20px' }}>Farmers Marketspace</p>
                                    <h1>PICKUP LOCATION</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
                {/* Same content width for title and map blocks (offset + flex-column centering skewed maps right) */}
                <div className="row justify-content-center mb-4">
                    <div className="col-12 col-md-10 col-lg-8 text-center">
                        <h2 className="mb-5">Pickup Locations</h2>
                    </div>
                </div>
                <div className="row justify-content-center mb-5">
                    <div className="col-12 col-md-10 col-lg-8 text-center">
                        <h4>Dubuque Farmer's Market</h4>
                        <p className="mb-3">101 W 11th St, Dubuque, IA 52001</p>
                        <iframe
                            title="Dubuque Farmer's Market Map"
                            src="https://www.google.com/maps?q=101+W+11th+St,+Dubuque,+IA+52001&output=embed"
                            width="100%"
                            height="300"
                            style={{ border: 0, display: 'block', margin: '0 auto' }}
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>
                <div className="row justify-content-center mb-5">
                    <div className="col-12 col-md-10 col-lg-8 text-center">
                        <h4>St Luke's Methodist Church</h4>
                        <p className="mb-3">1199 Main St, Dubuque, IA 52001</p>
                        <iframe
                            title="St Luke's Methodist Church Map"
                            src="https://www.google.com/maps?q=1199+Main+St,+Dubuque,+IA+52001&output=embed"
                            width="100%"
                            height="300"
                            style={{ border: 0, display: 'block', margin: '0 auto' }}
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>
            </div>

            <Footer />
            <CopyRight />
        </div>
    )
};

export default PickupLocation;